<template>
	<div class="can-i-use">
		<speaker-notes :notes="currentNotes"></speaker-notes>
		<h2>Can I Use?</h2>
		<div class="flex">
			<div>
				<h3>HTML5 AudioContext</h3>
				<p class="ac-option"><span class="check">✓</span> <span>Using the native AudioContext<br>to construct the buffers by hand.</span></p>
				<h3>Requirements:</h3>
				<ul>
					<li><span class="star">★★</span> AudioContext <span class="star">★★</span></li>
					<li>AudioContext.resume</li>
					<li>Promise</li>
					<li>mp3</li>
				</ul>
			</div>
			<div>
				<div class="browser-support" v-if="part === 1">
					<img src="@/assets/images/caniuse-ac.png" alt="Can I Use website for Audio Context"/>
					<img src="@/assets/images/caniuse-resume.png" alt="Can I Use website for Audio Context Resume"/>
					<img src="@/assets/images/caniuse-promise.png" alt="Can I Use website for Promises"/>
				</div>
				<div v-if="part > 1">
					<h3>Supported Browsers:</h3>
					<table :class="part === 2 ? 'current' : 'collapsed'">
						<thead>
						<tr>
							<th></th>
							<th>Browser</th>
							<th>Version</th>
							<th>Release Date</th>
						</tr>
						</thead>
						<tbody>
						<tr>
							<td><img src="@/assets/images/logo-chrome.png" alt="Chrome logo"/></td>
							<td>Chrome</td>
							<td>43</td>
							<td>May 2015</td>
						</tr>
						<tr>
							<td><img src="@/assets/images/logo-firefox.png" alt="Firefox logo"/></td>
							<td>Firefox</td>
							<td>40</td>
							<td>Aug 2015</td>
						</tr>
						<tr>
							<td><img src="@/assets/images/logo-safari.png" alt="Safari logo"/></td>
							<td>Safari</td>
							<td>9.1</td>
							<td>Mar 2016</td>
						</tr>
						<tr>
							<td><img src="@/assets/images/logo-edge.png" alt="Edge logo"/></td>
							<td>Edge</td>
							<td>13</td>
							<td>Nov 2015</td>
						</tr>
						<tr>
							<td><img src="@/assets/images/logo-ie.png" alt="IE logo"/></td>
							<td>IE</td>
							<td>Nope.</td>
						</tr>
						</tbody>
					</table>
				</div>
				<div v-if="part > 2" class="highlight">
					<h3>Recording</h3>
					<ul>
						<li>Entire other subject.</li>
						<li>Many browser differences.</li>
						<li>Requires https.</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import PageParts from "../helpers/page-parts";
	import SpeakerNotes from "../components/SpeakerNotes";

	export default {
		name: "can-i-use",
		components: {SpeakerNotes},
		mixins: [
			PageParts,
		],
		data() {
			return {
				notes: [
					[
						"The requirements are pretty basic any more.",
						"Suspending the AudioContext came later, and is important to handle, so you would have to write different code for a small number of browsers to avoid the resume() call.",
						"For instance, you'll notice that AudioContext is available in Firefox from version 25, but the resume is only available from version 40.",
						"You'll notice that it claims Safari doesn't support resume - it actually does."
					],
					[
						"Summary of the previous chart.",
						"Available everywhere for a few years.",
					],
					[
						"Recording is related and uses the same AudioContext and buffers.",
						"A whole nother talk.",
						"Recording has been a lot of experimentation.",
						"There isn't much visibility into what the browser is doing.",
						"Each browser release changes the rules."
					],
				],
			};
		}
	}
</script>

<style lang="scss" scoped>
	.can-i-use {
		text-align: center;
	}
	.flex {
		text-align: left;
	}
	.collapsed img {
		height: 22px;
		width: 32px;
	}
	.browser-support img {
		display: block;
		margin-bottom: 10px;
		width: 670px;
	}
	.ac-option {
		display: flex;
		align-items: center;
	}
	.check {
		color: $star-color;
		font-size: 100px;
		padding-right: 20px;
	}
	.star {
		color: $star-color;
	}
	table {
		th {
			padding-right: 20px;
		}
	}
	.highlight {
		background-color: $block-background;
		padding: 20px;
		margin-top: 40px;

		h3 {
			margin-top: 0;
		}
	}
	@media screen and (min-width: 800px) {
		.flex {
			display: flex;
			justify-content: space-evenly;
		}
	}

</style>
